import { useState } from "react"
import { KeyedMutator } from "swr"

import { MUST_LOG_OUT_AND_IN } from "./useAddGroup"
import {
    SUPPORT_REFER,
    SUPPORT_REFER_HELP_DESK,
} from "../../../../errors/errorMessages"
import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { snackbar } from "../../../../utils/general/generalUtils"
import { patchClientProtected } from "../../clients/clients"
import { TUsersOutput } from "../../mappers/adminPortal/activeUsersMapper"
import { REMOVE_FROM_GROUP } from "../../urls/private"

type IRemoveGroup = {
    removeGroup: (group: string, resetSwitchOnFail: () => void) => Promise<void>
    isLoading: boolean
}

const useRemoveGroup = (
    userName: string,
    fullName: string,
    mutate: KeyedMutator<TUsersOutput>
): IRemoveGroup => {
    const [isLoading, setIsLoading] = useState(false)
    const removeGroup = async (
        group: string,
        resetSwitchOnFail: () => void
    ): Promise<void> => {
        try {
            setIsLoading(true)
            await patchClientProtected(REMOVE_FROM_GROUP(userName, group), null)
            snackbar(
                `${fullName} successfully removed from this role. ${MUST_LOG_OUT_AND_IN}`,
                "success"
            )
            mutate()
        } catch (err) {
            const errorObj = parseErrorAsObj(err)

            let errorMsg
            if (errorObj?.code === 403) {
                errorMsg = `${errorObj?.message}. Please ${SUPPORT_REFER_HELP_DESK}`
            } else {
                errorMsg = `Unable to remove ${fullName} from group. Please try again. ${SUPPORT_REFER}`
            }

            resetSwitchOnFail()
            snackbar(errorMsg, "warning")
        } finally {
            setIsLoading(false)
        }
    }

    return {
        removeGroup,
        isLoading,
    }
}

export default useRemoveGroup
